import { autoinject, bindingMode } from 'aurelia-framework';
import { bindable } from 'aurelia-typed-observable-plugin';
import { ComponentBase, Sorting, SortDirection } from 'app/shared/lib/essette-site';
import { apiCall } from 'app/shared/lib/essette-api';
import { IQueryLoadOptions } from 'app/shared/lib/api/api-types';
import { EssPagerCustomElement } from 'app/shared/elements/ess-pager';
import { SortChangeEvent } from 'app/shared/attributes/sortable-attribute';
import { CaseService } from 'app/cm/services/case-service';
import * as CM from 'app/cm/models/essette-api';


@autoinject()
export class CaseAssignmentHistoryGrid extends ComponentBase {

    ////****************** Fields and Properties ************************************////
    @bindable.stringNull({ defaultBindingMode: bindingMode.toView, changeHandler: 'reload' })
    protected caseId: string | null = null;

    protected assignmentHistory: ReadonlyArray<CM.CaseAssignmentHistory> | null = null;

    private sorting: Sorting = new Sorting();
    protected resultCount: number = 0;
    protected pageSize: number = 25;


    ////****************** Element References ***************************************////
    protected $pager!: EssPagerCustomElement;


    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(
        private readonly service: CaseService,
        ...rest: any[]) {
        super(...rest);
    }

    protected async activate(): Promise<void> {
        this.loadAssignmentHistory();
    }


    ////****************** Events ***************************************************////
    /** Handles the grid's sort event */
    protected applySort(event: SortChangeEvent): void {
        const { property, direction } = event.detail;
        const { sorting } = this;
        if(direction === null) {
            sorting.remove(property);
        } else {
            sorting.add({
                reference: property,
                direction: direction === 'asc' ? SortDirection.Ascending : SortDirection.Descending
            });
        }
        this.reload();
        //Call stop Propagation to prevent parent table from reload and losing sort
        event.stopPropagation();
    }


    ////****************** Functions ************************************************////
    public async reload(): Promise<void> {
        this.loadAssignmentHistory();
    }


    ////****************** Service Calls ********************************************////
    @apiCall
    private async loadAssignmentHistory(): Promise<void> {
        if(!this.caseId) return;
        const options: Partial<IQueryLoadOptions> = {
            top: this.pageSize,
            page: this.$pager?.page || 0,
            sorting: this.sorting
        };

        const includes: string[] = ['user', 'metadata.started.byUser'];

        const fields: string[] = [
            'metadata.started.byUser.name.display',
            'metadata.started.timestamp',
            'user.name.display',
        ];

        try {
            this.state.beginLoad();
            const response = await this.service.loadAssignmentHistoryByCase(this.caseId, options, includes, fields);
            this.assignmentHistory = response.results;
            this.resultCount = response.count || 0;
        } catch(error) {
            throw error;
        } finally {
            this.state.endLoad();
        }
    }

}
